import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Toast,
  CheckList,
  Checkbox,
  Divider,
  Selector,
  Space
} from "antd-mobile";
import "./index.css";
import {Select} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import {
  parseQueryString,
  opt_apause_busType,
} from "../interface";
import axios from "axios";
import { domain } from "../interface";
import * as _ from "lodash";

let businessCode = {};
let endDates = {};
let start = {};
let pause = {};
let sysOrg =  {}
const AccountPause = () => {

  let navigate = useNavigate();
  let location = useLocation();

  const [pathUrl, setPathUrl] = useState(
    parseQueryString(window.location.href)
  );

  const [form] = Form.useForm();
  const [productVersion, setProductVersion] = useState({data:[]});
  const [customerCode, setCustomerCode] = useState("");
  const [products, setProducts] = useState([]);
  const [busType, setBusType] = useState("30");
  const [customerName, setcustomerName] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const [hasBuy, setHasBuy] = useState([]);
  const [noProduct, setNoProduct] = useState([]);
  


  const onBusTypeChange = (e) => {
    console.log(e);
    setBusType(e);
  };

  const onFinish = (values) => {
    let params = {
      ...values,
      "sysOrg":sysOrg
    };
  
  if (busType==="30" ){
    params.pause=pause
  }
  if (busType==="31" ){
    params.start=start
  }
  console.log(params)
    let userId = localStorage.getItem("userId");
    let userName = localStorage.getItem("userName");
    if (userName == null || userName == "") {
      userName = "邢汝华";
    }

    if (userId == null || userId == "") {
      userId = "ruhua";
    }
    // setIsDisabled(true);
    axios
      .post(domain + "/account/accountPause", {
        ...params,
        userId: userId,
        userName: userName,
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200 && res.data) {
          if (res.data.code == 200) {
            Toast.show({
              content: "保存成功",
            });
            //清空数字
            // fileListObj.splice(0, fileListObj.length);
            navigate("/home");
          } else {
            Toast.show({
              content: res.data.message,
            });
          }
        } else {
          Toast.show({
            content: "操作失败",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const  state  = location.state;

    if (state != null && state.hasStorage === "1") {
      //如果是查看详情跳转用跳转的id调用详情接口
      //否则是选择客户跳转
      const values = form.getFieldsValue();
      let objForm = {};
      for (let k in values) {
        objForm[k] =
          localStorage.getItem(k) != "undefined" &&
          localStorage.getItem(k) != "null"
            ? localStorage.getItem(k)
            : "";
      }
     
      setCustomerCode(
        localStorage.getItem("customerCode") != "undefined" &&
          localStorage.getItem("customerCode") != "null"
          ? localStorage.getItem("customerCode")
          : ""
      );

      setcustomerName(localStorage.getItem("customerName") || "");

      
      setHasBuy(
        localStorage.getItem("hasBuy") != "undefined" &&
          localStorage.getItem("hasBuy") != "null"
          ? JSON.parse(localStorage.getItem("hasBuy"))
          : []
      );

      setNoProduct(
        localStorage.getItem("noProduct") != "undefined" &&
          localStorage.getItem("noProduct") != "null"
          ? JSON.parse(localStorage.getItem("noProduct"))
          : []
      );

      setBusType(
        localStorage.getItem("busType") != "undefined" &&
          localStorage.getItem("busType") != "null"
          ? localStorage.getItem("busType")
          : "30"
      );     
      objForm.busType = localStorage.getItem("busType") 
      start={}
      pause={}
      sysOrg=state.sysOrg
      
      form.setFieldsValue({ ...objForm });
    } else {
      //新增表单
      // form.setFieldsValue({ module: "option-1676103442876" });
    }
  }, [pathUrl]);

  //跳转到选择客户页面
  const goCustomer = () => {
    const values = form.getFieldsValue();
    for (let k in values) {
      localStorage.setItem(k, values[k]);
    }
    localStorage.setItem("customerCode", customerCode);
    localStorage.setItem("navigate", "accountPause");
    localStorage.setItem("busType", busType);

    navigate("/customer");
  };

  return (
    <div className="page distributePage">
      <Form
        onFinish={onFinish}
        form={form}
        initialValues={{
          busType: "30",
        }}
        footer={
          !pathUrl.id && (
            <Button
              disabled={isDisabled}
              block
              type="submit"
              color="primary"
              size="large"
            >
              提交
            </Button>
          )
        }
      >
      <Form.Item
          name="busType"
          label="选择业务"
          rules={[{ required: true, message: "选择业务" }]}
        >
          <Select
            // className="editSelect"
            style={{
              width: 200,
            }}            
            disabled={pathUrl.id}
            onChange={onBusTypeChange}
            options={opt_apause_busType}
          >
          </Select>
        </Form.Item>

        <Form.Item
          className="customeNameBox"
          name="customerName"
          label="公司全称"
          rules={[{ required: true, message: "公司全称不能为空" }]}
        >
          <Input
            placeholder="选择公司全称"
            value={customerName}
            disabled
            autoComplete="off"
          />
            <Button
              onClick={() => {
                goCustomer();
              }}
              className="editCustomer"
              block
              color="primary"
              size="small"
            >
              选择公司
            </Button>
         
        </Form.Item>

        <Form.Item
          className="btnselect"
          name="customerCode"
          label="公司代码"
          rules={[{ required: true, message: "公司代码不能为空" }]}
        >
          <Input
            placeholder=""
            value={customerCode}
            disabled
            autoComplete="off"
          />
        </Form.Item>

        {  busType==="30"?<Divider>点击停用产品</Divider>:""}
          <Form.Item
            className="btnselect"
            hidden={busType!=="30"}
          >
            <Checkbox.Group>
              <Space direction='vertical'>
                    {hasBuy.map((item) => (
                      item.buy_shutStatus!==1?"":
                        <Checkbox  value={item.value}  
                          onChange={(ar) => {
                            let product={};
                            if (ar){  
                              product["businessCode"]=item.businessCode
                              product["versionCode"]=item.value
                              product["busType"]=busType
                              pause[item.value]=product
                            }else{
                              pause[item.value]={}
                            }  
                        }}>
                          {item.businessName}（{item.label}） 
                        </Checkbox>
                    ))}
                </Space>
              </Checkbox.Group>
          </Form.Item>  

          {busType==="31"?<Divider>选择启用产品</Divider>:""}
          <Form.Item
            className="btnselect"
            hidden={busType!=="31"}
          >
          <Checkbox.Group>
            <Space direction='vertical'>

                {hasBuy.map((item) => (
                  item.buy_shutStatus!==2?"":
                    <Checkbox  value={item.value}  
                      onChange={(ar) => {
                        let product={}
                        if (ar){  
                          product["businessCode"]=item.businessCode
                          product["versionCode"]=item.value
                          product["busType"]=busType
                          start[item.value]=product
                        }else{
                          start[item.value]={}
                        }  
                        console.log(ar,item.value)
                    }}>
                      {item.businessName}（{item.label}） 
                    </Checkbox>
                ))}
              </Space>
            </Checkbox.Group>
          </Form.Item>            
      </Form>
    </div>
  );
};
export default AccountPause;
